import DisableDevtool from 'disable-devtool'

const attachDevtopOpenEvent = () => {
  if (process.env.VUE_APP_ENV === 'production') {
    DisableDevtool({
      md5: '7befaf35023ba9b597a93b0972582d5c',
      disableMenu: false,
      timeOutUrl: 'https://404.html'
    })
  }
}

attachDevtopOpenEvent()
